// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BusinessOwnerDemographics,
  BusinessManagementStyle,
  BusinessPhilosophy,
  CanonicalAddress,
  OpLocationsJobStatusV1,
  BusinessStory,
} from "./types";


export default __t.row({
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
  deletedAt: __t.option(__t.timestamp()).name("deleted_at"),
  id: __t.uuid().primaryKey(),
  friendlyName: __t.string().name("friendly_name"),
  get demographics() {
    return __t.array(BusinessOwnerDemographics);
  },
  get managementStyles() {
    return __t.array(BusinessManagementStyle).name("management_styles");
  },
  get philosophies() {
    return __t.array(BusinessPhilosophy);
  },
  googlePlaceId: __t.option(__t.string()).name("google_place_id"),
  get businessAddress() {
    return CanonicalAddress.name("business_address");
  },
  businessCategory: __t.string().name("business_category"),
  businessType: __t.string().name("business_type"),
  websiteUrl: __t.option(__t.string()).name("website_url"),
  businessTags: __t.array(__t.string()).name("business_tags"),
  heroCdnPath: __t.option(__t.string()).name("hero_cdn_path"),
  colorPrimary: __t.option(__t.string()).name("color_primary"),
  colorSecondary: __t.option(__t.string()).name("color_secondary"),
  colorTertiary: __t.option(__t.string()).name("color_tertiary"),
  colorText: __t.option(__t.string()).name("color_text"),
  nominationClaim: __t.option(__t.string()).name("nomination_claim"),
  get opLocationsJobStatus() {
    return __t.option(OpLocationsJobStatusV1).name("op_locations_job_status");
  },
  opLocationsJobStarted: __t.option(__t.bool()).name("op_locations_job_started"),
  opLocationsJobAttempts: __t.option(__t.u32()).name("op_locations_job_attempts"),
  opLocationsJobCreatedAt: __t.option(__t.timestamp()).name("op_locations_job_created_at"),
  opLocationsJobLastPolledAt: __t.option(__t.timestamp()).name("op_locations_job_last_polled_at"),
  opLocationsJobCompletedAt: __t.option(__t.timestamp()).name("op_locations_job_completed_at"),
  opLocationsJobErrorKind: __t.option(__t.string()).name("op_locations_job_error_kind"),
  opLocationsJobErrorMessage: __t.option(__t.string()).name("op_locations_job_error_message"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  get businessStory() {
    return BusinessStory.name("business_story");
  },
});
